import type { EmblaCarouselType } from 'embla-carousel';
import type { AutoplayType } from 'embla-carousel-autoplay';

export const emblaPluginAutoscroll = (emblaApi: EmblaCarouselType) => {
  const autoScroll = emblaApi.plugins().autoScroll as AutoplayType | undefined;
  if (!autoScroll) return;
  autoScroll.play();

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        autoScroll.play();
      } else {
        autoScroll.stop();
      }
    });
  });
  io.observe(emblaApi.rootNode() as Element);

}